import { cx } from "@gf/ui";
import { Check } from "lucide-react";
import { SIGNUP_STEPS } from "./flow";

/** 1 Details · 2 Verify email · 3 Password · 4 Card */
export function SignupSteps({ current }: { current: 1 | 2 | 3 | 4 }) {
  return (
    <ol className="signup-steps" aria-label={`Step ${current} of ${SIGNUP_STEPS.length}`}>
      {SIGNUP_STEPS.map((label, i) => {
        const n = i + 1;
        const state = n < current ? "done" : n === current ? "current" : "todo";
        return (
          <li key={label} className={cx("signup-steps__item", `signup-steps__item--${state}`)} aria-current={state === "current" ? "step" : undefined}>
            <span className="signup-steps__dot" aria-hidden="true">
              {state === "done" ? <Check size={14} strokeWidth={3} /> : n}
            </span>
            <span className="signup-steps__label">
              {label}
              {state === "done" ? <span className="gf-sr-only"> (done)</span> : null}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
